module.exports = __webpack_public_path__ + "media/src/img/dzen-icon-blue-b7561b0b7feb06c2b07ac22c79802248.svg";